export const environment = {
  tag: 'production',
  apiUrl: window.origin,
  storeVersion: '1.0.0',
};
